import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";

/* ------------------------- Importaciones internas ------------------------- */
import { cancelButton, saveButton, approveButton} from "../../core/styles/ui.constants";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
    actionButton: saveButton,
    aprobarButton: { ...approveButton, marginLeft: theme.spacing(2) },
    cancelButton: { ...cancelButton, marginLeft: theme.spacing(2) },
    adjuntarButton: { ...saveButton, marginRight: theme.spacing(2) },
}));

const iconMap = {
    sinIconos: null,
    guardar: <CheckIcon />,
    nuevo: <AddCircleOutlineIcon />,
    aprobacion: <CheckIcon />,
    cancelar: <CloseIcon />,
    rechazar: <CloseIcon />,
    adjuntar: <AttachFileOutlinedIcon />,
};

const BotonGenerico = ({
    tipo = "cancelar",
    color = "primary",
    size = "medium",
    classesParams,
    disabled = false,
    onClick,
    text,
    icon,
}) => {
    const classes = useStyles();

    // determinar clase base según tipo
    let buttonClass;

    switch (tipo) {
        case "guardar":
        case "nuevo":
            buttonClass = classes.actionButton;
            break;
        case "adjuntar":
            buttonClass = classes.adjuntarButton;
            break;
        case "aprobar":
            buttonClass = classes.aprobarButton;
            break;
        default:
            buttonClass = classesParams ? classesParams : classes.cancelButton;
    }

    return (
        <Button
            variant="contained"
            color={color}
            size={size}
            startIcon={icon || iconMap[tipo] || null}
            onClick={onClick}
            className={`${buttonClass}`}
            disabled={disabled}
        >
            {text}
        </Button>
    );
};

export default BotonGenerico;
